import React, { useState } from 'react';
import Axios from 'axios';
import { Button, Typography, Box, TextField, FormControl } from "@mui/material";

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Send a request to your back-end to handle the password reset
    try {
      const response = await Axios.post(`/api/password-reset/`, { username: email });
      setMessage('Password reset link sent.');
    } catch (error) {
      setMessage('Error: Unable to reset password.');
    }
  };

  return (
    <Box
      sx={{
        maxWidth: '400px',
        margin: '200px auto',
        padding: '80px',
        backgroundColor: '#f5f5f5',
        borderRadius: '10px',
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
        marginTop: '80px'
      }}
    >
      <Typography variant="h3" sx={{ m: '0 0 20px 0', textAlign: 'center' }} >Forgot Password</Typography>
      <form onSubmit={handleSubmit}>
        <Box sx={{ m: '0 0 20px 0' }}>
          <Typography htmlFor="username" sx={{ m: '0 0 10px 0', display: 'block', fontWeight: 'bold'}}>
            Registered Email or Mobile Number:
          </Typography>
          <FormControl fullWidth variant="outlined" >
            <TextField
              size="small"
              id="username"
              label="Enter email or mobile number"
              name="username"
              value={email}
              onChange={handleEmailChange}
              required
            />
          </FormControl>
        </Box>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          size="large"
          fullWidth
          onClick={handleSubmit}
        >
          Reset Password
        </Button>
      </form>
      {message && (
        <p
          className="message"
          style={{
            textAlign: 'center',
            color: '#007bff',
            marginTop: '10px',
          }}
        >
          {message}
        </p>
      )}
    </Box>
  );
}
export default ForgotPassword;